var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4584 7.8186C21.9584 15.3186 16.4584 21.3186 9.45838 21.3186C7.04647 21.3186 4.63456 20.9954 2.74232 20.0892C2.30894 19.8817 2.47834 19.3036 2.95779 19.2718C5.28787 19.1173 7.21608 18.5609 8.45838 17.3186C3.04198 15.5131 2.10768 8.8181 3.08067 5.32579C3.19491 4.91573 3.72804 4.91359 3.94293 5.28106C5.60441 8.12231 8.76358 9.70863 12.723 9.34256C12.5517 8.86664 12.4584 8.35352 12.4584 7.8186C12.4584 5.33332 14.4731 3.3186 16.9584 3.3186C18.4766 3.3186 19.8192 4.07042 20.6342 5.22206L22.3513 4.97675C22.7792 4.91563 23.0778 5.38947 22.8381 5.74907L21.4584 7.8186Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.1a0216055b5ac90caad4cd5991652384.svg";
export { ForwardRef as ReactComponent };